<template>
    <div>
        <div 
            class="fade-up mb-4 mb-lg-5"
            style="min-height: 14vh; transition-delay: .1s;"
        >
            <h2> {{ $t(question.text) }} </h2>

            <p 
                v-if="question.explanation"
                class="mt-4"
            >
                {{ $t(question.explanation) }}
            </p>
        </div>

        <choices
            v-bind="$attrs"
            :choices="question.choices"
            v-on="$listeners"
        />
    </div>
</template>

<script>
import Choices from '@/components/test/question/Choices';

export default {
    name: 'MultipleChoices',
    components: { Choices },
    inheritAttrs: false,
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
};
</script>
